// src/i18n/locales/en/progress.ts

export default {
  title: 'Your Progress',
  subtitle: 'Track your success and stay motivated on your journey to your goal!',
  loadingData: 'Loading progress data...',

  header: {
    title: 'Your Progress',
    subtitle: 'Track your success and stay motivated on your journey to your goal!'
  },

  stats: {
    currentWeight: 'Current Weight',
    targetWeight: 'Target Weight',
    weightLost: 'Weight Lost',
    planAdherence: 'Plan Adherence',
    thisWeek: 'This Week',
    stillToGo: '{{amount}} kg to go',
    sinceStart: 'Since start',
    excellent: 'Excellent!',
    good: 'Good!',
    keepGoing: 'Keep going!',
    days: '{{count}} days',
    currentStreak: 'Current Streak',
    longestStreak: 'Longest Streak',
    totalDays: 'Active Days',
    weightEntries: 'Weight Entries',
    photoCount: 'Photos',
    sinceLast: 'Since last week',
    needsWork: 'Needs work'
  },

  weightChart: {
    title: 'Weight Progress',
    week: 'Week',
    month: 'Month',
    all: 'All',
    noData: 'No data available',
    addFirstEntry: 'Add your first weight',
    currentWeight: 'Current Weight',
    targetWeight: 'Target Weight',
    trend: 'Trend',
    timeRange: {
      week: '7 Days',
      month: '30 Days',
      quarter: '90 Days',
      all: 'All'
    }
  },

  weightHistory: {
    title: 'Weight History Details',
    logWeight: 'Log Weight',
    compare: 'Compare',
    selectForCompare: 'selected',
    table: {
      date: 'Date',
      weight: 'Weight',
      change: 'Change',
      toTarget: 'To Target',
      photo: 'Photo',
      status: 'Status',
      note: 'Note',
      actions: 'Actions'
    },
    noEntries: 'No entries yet',
    noEntriesSubtext: 'Add your first weight to track your progress',
    start: 'Start',
    confirmDelete: 'Are you sure you want to delete this entry?',
    deleteSuccess: 'Entry deleted',
    deleteError: 'Error deleting',
    compareMode: 'Compare Mode',
    cancelCompare: 'Cancel',
    gained: '+{{amount}} kg',
    lost: '-{{amount}} kg',
    noChange: 'No change',
    empty: 'No weight entries yet',
    emptySubtext: 'Start tracking your weight to see your progress.'
  },

  // weeklyReport: {
  //   title: 'Weekly Report',
  //   monday: 'Monday',
  //   tuesday: 'Tuesday',
  //   wednesday: 'Wednesday',
  //   thursday: 'Thursday',
  //   friday: 'Friday',
  //   saturday: 'Saturday',
  //   sunday: 'Sunday',
  //   weeklyRate: 'Weekly Rate',
  //   motivation: 'Keep it up!',
  //   motivationTextHigh: 'Outstanding consistency! You\'re crushing your nutrition goals. This kind of dedication will transform your results.',
  //   motivationTextMedium: 'Great effort this week! You\'re staying on track. A few more completed days will push you into the excellence zone.',
  //   motivationTextLow: 'Every day is a new opportunity. Don\'t let a tough week discourage you - tomorrow is your fresh start!'
  // },

  addWeight: {
    title: 'Add Weight',
    editTitle: 'Edit Weight',
    subtitle: 'Record your current weight',
    weight: 'Weight (kg)',
    weightPlaceholder: 'e.g. 75.5',
    date: 'Date',
    notes: 'Notes (optional)',
    notesPlaceholder: 'e.g. Motivated and ready!',
    photo: 'Progress Photo (optional)',
    uploadPhoto: 'Upload photo or drag here',
    fileTypes: 'PNG, JPG up to 10MB',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    tip: 'Tip',
    tipText: 'Weigh yourself in the morning after waking up and before breakfast for the most accurate results. Photos help you see changes that the scale doesn\'t show!',
    success: 'Weight recorded!',
    updateSuccess: 'Weight updated!',
    error: 'Error saving',
    invalidWeight: 'Please enter valid weight',
    uploadError: 'Please upload image files only',
    note: 'Note (optional)',
    notePlaceholder: 'e.g. After workout',
    save: 'Save'
  },

  weightDetail: {
    title: 'Progress from',
    subtitle: 'Your weight measurement',
    weight: 'Weight',
    targetWeight: 'Target Weight',
    toTarget: 'To Target',
    change: 'Change',
    start: 'Start',
    notes: 'Notes',
    progress: 'Progress',
    startMessage: 'This is your starting weight. You\'ve taken the first step!',
    progressMessage: 'You\'ve lost {{amount}} kg since the start. Keep going!',
    edit: 'Edit',
    share: 'Share',
    shareText: '🎉 Progress from {{date}}!\n\nWeight: {{weight}} kg\nTarget: {{target}} kg\n\n#NutriBot #Fitness #Progress',
    copiedToClipboard: 'Copied to clipboard!'
  },

  achievements: {
    title: 'Achievements',
    filterAll: 'All',
    unlocked: 'Unlocked',
    locked: 'Locked',
    notUnlocked: 'Not unlocked yet',
    unlockedOn: 'Achieved on',
    category: 'Category',
    details: 'Details',
    tip: 'Tip',
    download: 'Download',
    copy: 'Copy',
    share: 'Share',
    achievementUnlocked: 'Achievement Unlocked!',
    shareText: '🏆 I unlocked the "{{title}}" achievement!\n{{description}}\n\n#NutriBot #Fitness #Achievement',
    copiedToClipboard: 'Copied to clipboard!',
    subtitle: 'Your unlocked milestones',
    viewAll: 'View All',
    filterBy: 'Filter by',

    achieved: 'Achieved',
    // tip: 'Tip',
    downloadFailed: 'Failed to generate image',
    downloadSuccess: 'Achievement downloaded!',
    shareSuccess: 'Shared successfully!',
    imageDownloaded: 'Image downloaded! You can now share it manually.',
    // achievementUnlocked: 'Achievement Unlocked',


    categories: {
      all: 'All',
      weight_loss: 'Weight Loss',
      streak: 'Streaks',
      consistency: 'Consistency',
      milestones: 'Milestones',
      special: 'Special'
    },
    modal: {
      title: 'Achievement Details',
      description: 'Description',
      tips: 'Tips',
      unlockedAt: 'Unlocked',
      requirement: 'Requirement',
      progress: 'Progress',
      close: 'Close'
    },
    empty: 'No achievements unlocked',
    emptySubtext: 'Reach your goals to unlock achievements!',
    items: {
      firstSteps: {
        title: 'First Steps',
        description: '1 kg lost',
        details: 'You lost your first kilogram! This is the start of your transformation.',
        tips: 'Stay consistent with your plan and the results will follow.'
      },
      fiveKgMilestone: {
        title: '5 kg Milestone',
        description: 'First goal reached',
        details: '5 kilograms less! You are on the right path to your dream weight.',
        tips: 'Celebrate this success, but stay focused on your end goal.'
      },
      tenKgChampion: {
        title: '10 kg Champion',
        description: 'Reached target weight',
        details: 'Reach your target weight and become a champion of your health!',
        tips: 'Only a few more kilograms until your goal. You can do it!'
      },
      fifteenKgLegend: {
        title: '15 kg Legend',
        description: 'Exceptional performance',
        details: 'A legendary transformation! 15 kg is an impressive achievement.',
        tips: 'Maintain your new weight and enjoy your healthier life.'
      },
      threeDayStreak: {
        title: '3 Day Streak',
        description: 'Good start!',
        details: 'Three days in a row following your plan. Great start!',
        tips: 'The first days are the hardest. You are on the right track!'
      },
      sevenDayStreak: {
        title: '7 Day Streak',
        description: 'One week strong',
        details: 'A whole week consistently! Your discipline is paying off.',
        tips: 'After one week it becomes a habit. Keep it up!'
      },
      fourteenDayStreak: {
        title: '14 Day Streak',
        description: 'Two weeks power',
        details: 'Two weeks without interruption! You are a model of consistency.',
        tips: 'Your habits are now firmly established. Stay on track!'
      },
      thirtyDayStreak: {
        title: '30 Day Streak',
        description: 'One month strong',
        details: 'A whole month! This is true dedication and discipline.',
        tips: 'After 30 days it has become part of your life.'
      },
      sixtyDayStreak: {
        title: '60 Day Streak',
        description: 'Unstoppable',
        details: 'Two months without pause! You are an inspiration to others.',
        tips: 'You have proven that you can achieve anything you set your mind to.'
      },
      ninetyDayStreak: {
        title: '90 Day Streak',
        description: 'Lifestyle Champion',
        details: '90 days! Healthy eating is now your lifestyle.',
        tips: 'You have established a new lifestyle. Congratulations!'
      },
      earlyBird: {
        title: 'Early Bird',
        description: '10 weight entries',
        details: 'You are tracking your weight regularly. Great discipline!',
        tips: 'Regular tracking helps you stay on course.'
      },
      dataMaster: {
        title: 'Data Master',
        description: '30 weight entries',
        details: '30 entries! You are a master of self-monitoring.',
        tips: 'Your data shows your progress clearly.'
      },
      photoStarter: {
        title: 'Photo Starter',
        description: '5 progress photos',
        details: 'You are documenting your transformation visually!',
        tips: 'Photos show changes that the scale might not reveal.'
      },
      photoPro: {
        title: 'Photo Pro',
        description: '15 progress photos',
        details: 'Your photo documentation is impressive!',
        tips: 'You will love looking back at your journey.'
      },
      firstMonth: {
        title: 'First Month',
        description: '30 active days',
        details: 'One month active on NutriBot!',
        tips: 'You have built the foundation for long-term success.'
      },
      quarterChampion: {
        title: 'Quarter Champion',
        description: '90 active days',
        details: 'Three months of dedication!',
        tips: 'You are proof that consistency wins.'
      },
      halfYearHero: {
        title: 'Half Year Hero',
        description: '180 active days',
        details: 'Six months! This is a true lifestyle change.',
        tips: 'You have completely transformed your habits.'
      },
      yearLegend: {
        title: 'Year Legend',
        description: '365 active days',
        details: 'One full year! You are a nutrition legend!',
        tips: 'Your dedication is an inspiration to everyone.'
      }
    }
  },

  comparePhotos: {
    title: 'Progress Comparison',
    subtitle: 'Before & After',
    before: 'Before',
    after: 'After',
    weightLoss: 'Weight Loss',
    timeframe: 'Timeframe',
    days: '{{count}} days',
    dragToCompare: 'Drag the slider to compare',
    beforeNotes: 'Before - Notes',
    afterNotes: 'After - Notes',
    noPhotos: 'No photos available',
    noPhotosSubtext: 'At least one of the selected entries has no photo',
    progress: 'Fantastic Progress!',
    progressMessage: 'You\'ve lost {{amount}} kg in {{days}} days! That\'s a great achievement. Keep it up and you\'ll reach your goal! 💪',
    motivationMessage: 'Every step counts on your journey. Stay focused and the results will follow! 🌟'
  },

  progressPhotos: {
    title: 'Progress Photos',
    selectForCompare: '{{count}}/2 selected for comparison',
    noPhotos: 'No photos yet',
    noPhotosSubtext: 'Document your transformation visually',
    tip: 'Tip',
    tipText: 'Select 2 photos to see a before-after comparison!',
    gallery: 'Photo Gallery',
    upload: 'Upload Photo',
    empty: 'No photos yet',
    emptySubtext: 'Document your transformation visually.',
    compare: 'Compare Photos',
    delete: 'Delete Photo',
    confirmDelete: 'Are you sure you want to delete this photo?',
    gridView: 'Grid View',
    listView: 'List View',
    photosCount: '{{count}} photos'
  },

  weeklyReport: {
    title: 'Weekly Summary',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    weeklyRate: 'Weekly Rate',
    motivation: 'You\'re doing great!',
    motivationText: 'With your current plan adherence of 92%, you\'re on the best path to reaching your goal. Keep it up — you can do it! 💪',

    // motivation: 'Keep it up!',
    motivationTextHigh: 'Outstanding consistency! You\'re crushing your nutrition goals. This kind of dedication will transform your results.',
    motivationTextMedium: 'Great effort this week! You\'re staying on track. A few more completed days will push you into the excellence zone.',
    motivationTextLow: 'Every day is a new opportunity. Don\'t let a tough week discourage you - tomorrow is your fresh start!',

    weightChange: 'Weight Change',
    avgCalories: 'Avg Calories/Day',
    planAdherence: 'Plan Adherence',
    completedMeals: 'Completed Meals',
    trend: 'Trend',
    exportPDF: 'Export as PDF',
    weekDays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  },

  buttons: {
    addWeight: 'Add Weight',
    uploadPhoto: 'Upload Photo',
    viewDetails: 'View Details',
    delete: 'Delete',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    compare: 'Compare',
    download: 'Download'
  },

  uploadPhoto: {
    title: 'Upload Progress Photo',
    selectFile: 'Select Photo',
    dragDrop: 'Or drag and drop here',
    maxSize: 'Max. 5 MB',
    date: 'Date',
    weight: 'Weight (optional)',
    weightPlaceholder: 'e.g. 75.5',
    note: 'Note (optional)',
    notePlaceholder: 'e.g. Week 4',
    cancel: 'Cancel',
    upload: 'Upload',
    success: 'Photo uploaded!',
    error: 'Upload failed',
    compressing: 'Compressing image...',
    uploading: 'Uploading...'
  },

  success: {
    weightAdded: 'Weight entry added!',
    weightDeleted: 'Entry deleted',
    photoUploaded: 'Photo uploaded!',
    photoDeleted: 'Photo deleted',
    achievementUnlocked: '🎉 Achievement Unlocked: {{title}}'
  },

  error: {
    loadFailed: 'Failed to load',
    addFailed: 'Failed to add',
    deleteFailed: 'Failed to delete',
    uploadFailed: 'Upload failed',
    invalidFile: 'Invalid file',
    fileTooLarge: 'File too large (max. 5 MB)',
    required: 'Required field',
    invalidWeight: 'Invalid weight',
    invalidDate: 'Invalid date'
  }
};